import { Box, Paper, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { toStory } from '../../utils/routes';
import { useTranslation } from 'react-i18next';

export default function Story(props) {
    
    const {i18n} = useTranslation();
    
    const navigate = useNavigate();

    let {storyId, frameId} = useParams();
    const story = props.stories.find(val => val.id === storyId);
    let frame;
    if (!frameId) {
        frame = props.frames.find(val => val.substoryId === storyId);
    } else {
        frame = props.frames.find(val => val.id === frameId);
    }
    const choices = frame && props.choices.find(val => val.frameId === frame.id);
    const character = frame && props.characters.find(val => val.frameId === frame.id);
    const bubble = frame && props.bubbles.find(val => val.frameId === frame.id);

    useEffect(() => {
        if (!frameId) {
            const firstFrameId = 
                props.frames && props.frames.length > 0 ? 
                props.frames.find(val => (val.substoryId === storyId) && val.first).id : 
                "";
            moveToFrame(firstFrameId, true);
        }
    }, [story])
    
    const mainPath = toStory(storyId);

    const moveToFrame = (nextFrameId, isFirst=false) => {
        if (
            !nextFrameId
        )   {
            navigate(mainPath + "/finished");
        } else {
            navigate(mainPath + "/" + nextFrameId, {replace: isFirst});
        }
    }

    if (storyId && story && frame && character && bubble) {
        return(
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    m: 4,
                }}>
                <Paper sx={{ mb: 2, mt: 4, p: 1}}>
                    <Typography variant="h1" align="center" sx={{m: 0}}>{story.title[i18n.language]}</Typography>
                </Paper>
                <Outlet context={[frame, choices, character, bubble, moveToFrame]}/>
            </Box>
        )} else {
        return null;
    }
}